/**
 * Hides PrimeNG's read-only hour/minute spinner, which
 * `U2bDatePickerTimeInputComponent` replaces with typable fields. Bind it as
 * `[pt]` on every `<p-datepicker [showTime]>` that renders
 * `<u2b-date-picker-button-bar>`, or the panel shows both clocks.
 *
 * `style` and not `class`: the timepicker element carries PrimeNG's own `[class]`
 * binding next to the pass-through one, and the two overwrite each other.
 */
export const U2B_DATE_PICKER_CUSTOM_TIME_PT = {
    timePicker: { style: { display: 'none' } },
};
